/**
 * Image Uploader Directive.
 * Uploads the picture data in browser memory.
 *
 * Example:
 * <input type="file" jv-image-uploader="{maxSize:10485760, model:'myAccount.profilePic', flag:'anyFlag'}" />
 *
 * Params:
 * 'maxSize' is the max size of the file permitted to be uploaded.
 * 'model' is the scope ngModel in which the file data will be saved.
 * 'flag' is set to true once the file is uploaded [model.anyFlag = true]
 *
 * FILE SIZE VALIDATION
 * if fileSize is more than maxSize, then the value [model.fileSizeExceeded = true] and returns.
 * else [model.fileSizeExceeded = false]
 *
 * Once file is uploaded,
 * the file metadata is stored in model.fileData
 * the image is stored in model.uploadedPic [use it as img ng-src="model.uploadedPic"]
 * the flag is set to true : [model.anyFlag = true]
 *
 * Required files:
 * polyfill.js
 */

angular.module('jv.Common.Directives.ImageUploader', [])
.directive('jvImageUploader', ['$parse', function($parse) {
	return {
		link: function (scope, elm, attrs) {
			var options = scope.$eval(attrs.jvImageUploader);
			var model = scope.$eval(options.model);
			var ngModel = $parse(options.model);
			var ngFlag = $parse(options.flag);

			$(elm).on('change', function(event){
				var file = $(event.target);
				var files = file.prop('files');

				if(files[0].type.indexOf("image/") < 0){
					model.invalidImageType = true;
					ngModel.assign(scope, model);
					scope.$apply();
					return;
				}else{
					model.invalidImageType = false;
				}

				if(options.maxSize){
					if(files[0].size > parseInt(options.maxSize)){
						model.fileSizeExceeded = true;
						ngModel.assign(scope, model);
						scope.$apply();
						return;
					}else{
						model.fileSizeExceeded = false;
					}
				}

				var reader = new FileReader();

				reader.onload = (function(theFile) {
					return function(e) {
						if(!model.uploadedPic){
							model= angular.extend({
								uploadedPic : ""+e.target.result
							}, model);
						}else{
							model.uploadedPic = e.target.result;
						}
						model.fileData = theFile;
						ngFlag.assign(model, true);
						ngModel.assign(scope, model);
						scope.$apply();
					};
				})(files[0]);

				reader.readAsDataURL(files[0]);
			});
		}
	};
}]);